<p-confirmDialog key="root" styleClass="app-confirm-dialog"></p-confirmDialog>
<div class="auth-warning-confirm-wrap">
  <p-confirmDialog key="authWarning"></p-confirmDialog>
</div>
<router-outlet></router-outlet>

<p-toast key="root"></p-toast>
